import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import LotForm from '../diy-forms/LotForm';
import LotRealizedForm from '../diy-forms/LotRealizedForm';
import validateLotForm from '../diy-utils/validateLotForm';
import validateLotCatalogForm from '../diy-utils/validateLotCatalogForm';

class EditLotModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lotData: null,
      showEditLotModal: false,
      validation: {
        lotNumber: null,
        lotExt: null,
        lotTitle: null,
        lotDescription: null,
        shipWidth: null,
        shipHeight: null,
        shipLength: null,
        shipWeight: null,
        loEst: null,
        hiEst: null,
        startingBid: null,
        invNumber: null,
        reserve: null
      }
    };
  }

  /**
   * We need to use GDSFP here in order to load new lot data from props
   * into the initial state whenever a user launches a modal.
   *
   * This ensures the correct 'fresh' data whenever a user closes and opens a
   * new edit modal for a different lot in the table.
   *
   * This is important since we need to modify these values inside this component's
   * state as well.
   */
  static getDerivedStateFromProps(props, state) {
    const { editLotValidation, showEditLotModal } = props;
    if (showEditLotModal !== state.showEditLotModal) {
      const { lotData } = props;

      return {
        showEditLotModal,
        lotData,
        validation: editLotValidation
      };
    }

    return null;
  }

  // Dynamically set changed input fields in the state
  handleInputChange = e => {
    const { id, value } = e.target;
    const { validation } = this.state;

    // Clear validation until the user exits the field
    delete validation[id];

    this.setState({
      lotData: {
        ...this.state.lotData,
        [id]: value
      },
      validation
    });
  };

  validateFields = async fieldName => {
    const { deletedLots, invNumberArray, lotNumberArray, type, lots, lotNotFound, isGoldPlatinum } = this.props;
    const { lotData, validation } = this.state;

    const isNotOnFile = !lots?.some(lotNum => (lotNum.lotNumber + lotNum.lotExt.toUpperCase()
        === lotData.lotNumber + lotData.lotExt.toUpperCase()));
    if (type === 'realized') {
      //If is a known non-existent Lot, it should only notify
      if (lotNotFound && lotNotFound === lotData.lotNumber + lotData.lotExt.toUpperCase()) {
        this.setState({
          validation: {
            lotNumber: 'This lot number was not a part of this catalog.',
            lotExt: null,
            realizedPrice: null
          }
        });
      } else if ((fieldName === 'lotNumber' || fieldName === 'lotExt')
           && isNotOnFile) {
        // go to DB to check if exist
        this.setState({ validation:
          await this.props.validateFieldsRealized(lotData, validation) });
      } else {
        this.setState({
          validation: validateLotCatalogForm({
            fieldName,
            lotData,
            lotNumberArray,
            validation,
            lots,
          })
        });
      }
    } else {
      this.setState({
        validation: validateLotForm(
          deletedLots,
          fieldName,
          invNumberArray,
          lotData,
          lotNumberArray,
          type,
          validation,
          isGoldPlatinum,
        )
      });
    }
  };

  render() {
    const { showEditLotModal } = this.props;

    if (!showEditLotModal) {
      return null;
    }

    const { handleModal, hasOrderBids, modalName, submitEditLot, type, isGoldPlatinum } = this.props;

    /**
     * I need this as a full object as well below since BE probably needs every single field, not
     * just the ones we actually are using.
     */
    const { lotData, validation } = this.state;

    // Disable the save button if there are validation errors
    const isModalDisabled = Object.keys(validation).some(key => validation[key]);

    return (
      <Modal
        className="form-modal edit-lot-modal-width"
        isOpen={showEditLotModal}
        toggle={() => handleModal(modalName, false)}
        onEnter={() => { this.validateFields(); }}
      >
        <ModalHeader className="pb-0" toggle={() => handleModal(modalName, false)} tag="h1">
          Edit Item
        </ModalHeader>
        <ModalBody className="pt-0">
          <p>* = Required</p>

          {type !== 'realized' && (
          <LotForm
            handleInputChange={this.handleInputChange}
            hasOrderBids={hasOrderBids}
            lotData={lotData}
            type={type}
            validateFields={this.validateFields}
            validation={validation}
            isGoldPlatinum={isGoldPlatinum}
          />
          )}

          {type === 'realized' && (
          <LotRealizedForm
            handleInputChange={this.handleInputChange}
            lotData={lotData}
            type={type}
            validateFields={this.validateFields}
            validation={validation}
          />
          )}

        </ModalBody>

        <ModalFooter>
          <Button
            className={isModalDisabled ? 'mr-3 cursor-not-allowed' : 'mr-3'}
            color="primary"
            disabled={isModalDisabled}
            onClick={() => submitEditLot(lotData)}
          >
            Save Item
          </Button>
          <Button color="link" onClick={() => handleModal(modalName, false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditLotModal;
